import api from "../BrandOnBoarding/api";
import { displayDateTime } from "../utils/helpers";

const baseURL = process.env.REACT_APP_BASE_URL;
// const baseURL = 'http://localhost:8080/api'

//TODO: change this firebase function
const handleLlmUsageMeasure = async (model, functionalityUsage, status) => {
  // if (window.location.hostname !== "www.brandluminaire.ai") {
  //   const apiMeasurePayload = {
  //     llm: model,
  //     // date: displayDateTime(),
  //     date: "",
  //     functionalityUsage: functionalityUsage,
  //     status: status,
  //   };
  //   const url = `https://us-central1-brand-luminaire.cloudfunctions.net/addLlmUsageMeasure`;
  //   const API_CONFIG = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(apiMeasurePayload),
  //   };

  //   await fetch(url, API_CONFIG);
  // }
};

export async function fetchGooeyAPI(
  inputPrompt,
  selectedOption,
  abortController
) {
  const payload = {
    input_prompt: inputPrompt,
    selected_models: [selectedOption], // Modify to handle one selected item at a time
    avoid_repetition: false,
    num_outputs: 1,
    quality: 1,
    max_tokens: 800,
    sampling_temperature: 0.7,
    variables: null,
  };

  try {

    const response = await api.post('/fetchGooeyAPI', payload, {
      signal: abortController?.signal,
    });

    // axios returns data in response.data
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchGpt4API(
  inputPrompt,
  abortController,
  max_tokens = 800,
  temperature = 1,
  model = "gpt-4",
  response_format = {},
  functionalityUsage = "Reporting"
) {
  let payload = {
    messages: [
      {
        role: "user",
        content: inputPrompt,
      },
    ],
    max_tokens: max_tokens,
    model: model,
  };

  if (model !== "gpt-4o-search-preview") {
    payload = {
      ...payload,
      temperature,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0,
    };
  }

  if (Object.keys(response_format).length > 0) {
    payload.response_format = response_format;
  }

  try {
    const response = await api.post('/fetchGptAPI', payload, {
      signal: abortController?.signal,
    });
    // if (response.status !== 200) {
    //   throw new Error();
    // }
    await handleLlmUsageMeasure(model, functionalityUsage, "processed");
    // return response.json();
    return response.data;
  } catch (err) {
    await handleLlmUsageMeasure(model, functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchGpt5API(
  inputPrompt,
  abortController,
  max_output_tokens = 800,
  model = "gpt-5.6",
  functionalityUsage = "Reporting",
  useWebSearch = false
) {
  const payload = {
    input: [
      {
        role: "user",
        content: inputPrompt,
      },
    ],
    max_output_tokens,
    model,
    useWebSearch,
  };

  try {
    const response = await api.post('/fetchGpt5API', payload, {
      signal: abortController?.signal,
    });
    await handleLlmUsageMeasure(model, functionalityUsage, "processed");
    return response.data;
  } catch (err) {
    await handleLlmUsageMeasure(model, functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchLlama2API(
  inputPrompt,
  abortController,
  temperature = 0.9,
  functionalityUsage = "Reporting"
) {
  const payload = {
    messages: [{ role: "user", content: inputPrompt }],
    temperature,
  };
  try {
    const response = await api.post('/fetchLlama2API', payload, {
      signal: abortController?.signal,
    });
    // if (response.status !== 200) {
    //   throw new Error();
    // }
    await handleLlmUsageMeasure("Llama2", functionalityUsage, "processed");
    // return response.json();
    return response.data;
  } catch (err) {
    await handleLlmUsageMeasure("Llama2", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchLlama3API(
  inputPrompt,
  abortController,
  temperature = 0.1,
  functionalityUsage = "Reporting"
) {
  const payload = {
    messages: [{ role: "user", content: inputPrompt }],
    temperature,
  };
  try {
    const response = await api.post('/fetchLlama3API', payload, {
      signal: abortController?.signal,
    });
    // if (response.status !== 200) {
    //   throw new Error();
    // }
    await handleLlmUsageMeasure("Llama3", functionalityUsage, "processed");
    // return response.json();
    return response.data;
  } catch (err) {
    await handleLlmUsageMeasure("Llama3", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchSlackAPI(payload, abortController) {
  try {
    const response = await api.post('/fetchSlackAPI', payload, {
      signal: abortController?.signal,
    });
    // if (response.status !== 200) {
    //   throw new Error();
    // }
    // return response.json();
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchClaude3API(
  inputPrompt,
  abortController,
  temperature = 1.0,
  max_tokens = 2000,
  functionalityUsage = "Reporting"
) {
  const payload = {
    model: "claude-sonnet-4-6",
    max_tokens,
    temperature,
    messages: [{ role: "user", content: inputPrompt }],
  };
  try {
    const response = await api.post('/fetchClaude3API', payload, {
      signal: abortController?.signal,
    });
    await handleLlmUsageMeasure("Claude4", functionalityUsage, "processed");
    // return response.json();
    return response.data;
  } catch (err) {
    await handleLlmUsageMeasure("Claude4", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchPerplexityAPI(
  inputPrompt,
  abortController,
  temperature = 1.0,
  max_tokens = 2000,
  model = "sonar",
  functionalityUsage = "Reporting"
) {
  const payload = {
    model,
    messages: [
      {
        role: "user",
        content: inputPrompt,
      },
    ],
    max_tokens,
    temperature,
  };
  try {
    const response = await api.post('/fetchPerplexityAPI', payload, {
      signal: abortController?.signal,
    });
    await handleLlmUsageMeasure("Perplexity", functionalityUsage, "processed");
    // return response.json();
    return response.data;
  } catch (err) {
    await handleLlmUsageMeasure("Perplexity", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function fetchGeminiAPI(
  inputPrompt,
  abortController,
  temperature = 0.9,
  functionalityUsage = "Reporting"
) {
  const payload = { llm: "Gemini", prompt: inputPrompt, temperature };
  try {
    const response = await api.post('/fetchGeminiAPI', payload, {
      signal: abortController?.signal,
    })
    await handleLlmUsageMeasure("Gemini", functionalityUsage, "processed");
    // return response.json();
    return response.data;
  } catch (err) {
    await handleLlmUsageMeasure("Gemini", functionalityUsage, "failed");
    throw new Error(err);
  }
}

export async function checkWebLink(link, abortController) {
  const payload = { link };
  const response = await api.post('/checkWebLink', payload, {
    signal: abortController.signal,
  });
  return response.data;
}

export async function fetchDataFromChatGPTWeb(payload, abortController) {
  try {
    const response = await api.post('/fetchDataFromChatGPTWeb', payload, {
      signal: abortController?.signal,
    });
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchFromGoogleSGE(inputPrompt, abortController) {
  const id = crypto.randomUUID();
  const payload = { prompt: inputPrompt, id: id };
  try {
    const response = await api.post('/fetchFromGoogleSGE', payload, {
      signal: abortController?.signal,
    });
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function addReportingJob(payload, abortController) {
  try {
    const response = await api.post('/addReportingJob', payload, {
      signal: abortController?.signal,
    });
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function triggerReportingJob(payload, abortController) {
  try {
    const response = await api.post('/triggerReportingJob', payload, {
      signal: abortController?.signal,
    });
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function fetchBrandNames() {
  
  const response = await api.get('/getbrands');
  return response.data;
}

export async function fetchProductNames() {
  
  const response = await api.get('/getproducts');
  return response.data;
}

export async function fetchLlms() {
  
  const response = await api.get('/getllms');
  return response.data;
}

export async function getLlms() {
  
  const response = await api.get('/llms');
  return response.data;
}

export async function getMarkets() {
  
  const response = await api.get('/markets');
  return response.data;
}

export async function getGeographies() {
  
  const response = await api.get('/geographies');
  return response.data;
}

export async function fetchCustomerLlms(id) {
  
  const response = await api.post('/customers/llms', { id });
  return response.data;
}

export async function getCustomerLlmGeoMarket(payload) {
  
  const response = await api.post('/customers/customer-llm-geo-market', payload);
  return response.data;
}

export async function getAttributes(payload) {
  
  const response = await api.post('/getattributes', payload);
  return response.data;
}

export async function getProductAttributes(payload) {
  
  const response = await api.post('/product-attributes', payload);
  return response.data;
}

export async function getBrandAttributes(payload) {
  
  const response = await api.post('/brand-attributes', payload);
  return response.data;
}

export async function getActionSources(payload) {
  
  const response = await api.post('/metrics/metric-action-sources', payload);
  return response.data;
}

export async function getProductCoreAttributes(payload) {
 
  const response = await api.post('/product-core-attributes', payload);
  return response.data;
}

export async function getBrandCoreAttributes(payload) {
  
  const response = await api.post('/brand-core-attributes', payload);
  return response.data;
}

export async function getBrandIndexScore(payload, abortController) {
  
  const response = await api.post('/metrics/get-brand-index-score', payload, {
    signal: abortController.signal,
  });
  return response.data;
}

export async function getBrandIndexScores(payload, abortController) {
  
  const response = await api.post('/getbrandindexscores', payload, {
    signal: abortController.signal,
  });
  return response.data;
}

export async function getIndexScoreForBrand(payload) {
  
  const response = await api.post('/brand-index-score', payload);
  return response.data;
}

export async function getIndexScoreForProduct(payload) {
  
  const response = await api.post('/product-index-score', payload);
  return response.data;
}

export async function generateBrandMetrics(llmId, brandPersonaId) {
  
  const response = await api.post('/generate-brand-metrics', { llmId, brandPersonaId });
  return response.data;
}

export async function generateProductMetrics(llmId, brandProductPersonaId) {
  
  const response = await api.post('/generate-product-metrics', { llmId, brandProductPersonaId });
  return response.data;
}

export async function getCompMetricsForProduct(payload) {
  
  const response = await api.post('/product-comp-metrics', payload);
  return response.data;
}

export async function getCustomerMetrcisAlertsData(payload) {
 
  const response = await api.post('/customer-metrics-alerts-data', payload);
  return response.data;
}

export async function getCustomerEfrLlm(payload) {
  
  const response = await api.post('/customer-efr-llm', payload);
  return response.data;
}

export async function getSourcesWithAlias(payload) {
  
  const response = await api.post('/source-alias', payload);
  return response.data;
}

export async function addActionsIntoList(payload, id) {
  
  const response = await api.post(`/customer/${id}/action-list`, payload);
  return response.data;
}

export async function getCompMetricsForBrand(payload) {
  
  const response = await api.post('/brand-comp-metrics', payload);
  return response.data;
}

export async function getNonActionableMetricData(payload) {
  
  const response = await api.post('/non-actionable-data', payload);
  return response.data;
}

export async function getSummaryDataForBrandProduct(
  customerLlmId,
  customerPersonaId
) {
  
  const response = await api.post('/customer-brand-product-summary', { customerLlmId, customerPersonaId });
  return response.data;
}
function cleanMarkdownString(input) {
  let cleaned = input.trim().replace(/^```|```$/g, "");
  cleaned = cleaned.replace(/^(markdown|md)\s*/i, "");
  return cleaned.trim();
}

export async function llmWeb(llm, focus_area, brand, attributes, prompt) {
  const payload = {
    llm: llm,
    focus_area,
    brand: brand,
    attributes: attributes,
    prompt: prompt,
  };
  try {
    
    const response = await api.post('/llm-web', payload, { signal: new AbortController()?.signal });
    const data = response.data;
    return {
      LLM_WEB: [cleanMarkdownString(data["LLM_WEB"])],
    };
  } catch (err) {
    throw new Error(err);
  }
}

export async function getCustomerCases(customerId) {
  
  const response = await api.get(`/customer/${customerId}/customer-case-list`);
  return response.data;
}

export async function getCustomerActiveMonitoringRecords(customerId) {
  // const url = `${baseURL}/customer/${customerId}/customer-active-monitoring-records`;
  // const token = localStorage.getItem("token");
  // const API_CONFIG = {
  //   method: "GET",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${token}`,
  //   },
  // };
  // const result = await fetch(url, API_CONFIG);
  // return result.json();

  const response = await api.get(`/customer/${customerId}/customer-active-monitoring-records`);
  return response.data;
}



export async function getCustomerMonitoringFiletrs(customerId) {
  
  const response = await api.get(`/customers/${customerId}/customer-monitoring-filters`);
  return response.data;
}

export async function getCustomerMonitoringDates(customerId, payload) {

  const response = await api.post(`/customers/${customerId}/customer-monitoring-dates`, payload);
  return response.data;
}

// ── Conversation Monitoring V3 (customer_conversation_monitoring[_output]) ──

export async function getConversationMonitoringOptions(customerId) {
  const response = await api.get('/conversation-monitoring/options', {
    params: { customer_id: customerId },
  });
  return response.data;
}

export async function getConversationMonitoringDates({ customerId, category, entity, persona }) {
  const response = await api.get('/conversation-monitoring/dates', {
    params: { customer_id: customerId, category, entity, persona },
  });
  return response.data;
}

export async function getConversationMonitoringDetail({ customerId, category, entity, persona, date }) {
  const response = await api.get('/conversation-monitoring/detail', {
    params: { customer_id: customerId, category, entity, persona, date },
  });
  return response.data;
}

export async function getConversationMonitoringTrend({ customerId, category, entity, persona, limit }) {
  const response = await api.get('/conversation-monitoring/trend', {
    params: { customer_id: customerId, category, entity, persona, limit },
  });
  return response.data;
}

// Downloads the monitoring JSON (single run, or [recent, baseline] when
// compareRunId is given). Errors are rethrown with the server's message.
export async function downloadConversationMonitoringJson({ customerId, category, entity, persona, runId, compareRunId }) {
  try {
    const response = await api.get('/conversation-monitoring/export', {
      params: { customer_id: customerId, category, entity, persona, run_id: runId, compare_run_id: compareRunId },
      responseType: 'blob',
    });

    const disposition = response.headers?.['content-disposition'] || '';
    const match = disposition.match(/filename="?([^";]+)"?/i);
    const filename = match?.[1] || `${entity}_${category}.json`;

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/json' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // responseType 'blob' turns the JSON error body into a Blob — read the message back out.
    let message = error.message;
    const body = error.response?.data;
    if (body instanceof Blob) {
      try {
        message = JSON.parse(await body.text())?.message || message;
      } catch (_) {}
    }
    throw new Error(message);
  }
}

export async function getCustomerBrandProductCases(
  customerId,
  brand_names,
  product_names
) {
  
  const response = await api.post(`/customer/${customerId}/customer-brand-product-associations`, { brand_names, product_names });
  return response.data;
}

export async function getAllBrands() {
  
  const response = await api.get('/customers/brands');
  return response.data;
}

export async function getDashboardSummary(payload) {
  
  const response = await api.post('/generate-dashboard-summary', payload);
  return response.data;
}

export async function getHomepageNews(payload) {
  
  const response = await api.post('/get-homepage-news', payload);
  return response.data;
}

export async function getActionMetricsData(payload) {
  
  const response = await api.post('/action-metrics', payload);
  return response.data;
}

export async function getRealtimeActions(payload) {
  
  const response = await api.post('/realtime-actions', payload);
  return response.data;
}

export async function getRealtimeActionsSource(payload) {
 
  const response = await api.post('/realtime-actions-sources', payload);
  return response.data;
}

export async function getRecommendedActions(customerId) {
  
  const response = await api.get(`/get-recommended-actions/${customerId}`);
  return response.data;
}

export async function newVersionAvailableToRefresh() {
  try {
    // const response = await fetch(`${baseURL}/utils/get-frontend-version`);
    const response = await api.get('/utils/get-frontend-version');

    if (!response.ok) return false; // Handle non-200 status codes

    const { frontend_build_version } = await response.json();
    const local_version = localStorage.getItem("frontend_build_version");

    // Compare current version with local version and update if needed
    if (+local_version !== +frontend_build_version) {
      localStorage.setItem("frontend_build_version", frontend_build_version);
      return true; // New version available
    }

    return false; // No new version
  } catch (error) {
    console.error("Error fetching version:", error);
    return false; // Return false in case of an error
  }
}

export async function getReportingData(customerId) {
  try {
    // const response = await fetch(`${baseURL}/llm-reporting`, {
    // const response = await fetch(
    //   `${baseURL}/llm-reporting?customer_id=${customerId}`
    // );
    const response = await api.get(`/llm-reporting?customer_id=${customerId}`);
    if (!response.ok) return false;
    // const reportData = await response.json();
    const reportData = response.data;
    return reportData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
}

export async function updateReportingData(payload) {
  try {
    
    const response = await api.post('/llm-reporting', payload);
    return response.data;
  } catch (error) {
    console.error("Error :", error);
    return null; // Return false in case of an error
  }
}
